import FrameTempleSelect from '@screens/frame/temple/select'

export default function FrameTempleSelectPage() {
  return <FrameTempleSelect />
}
